export default {
  companyState: {},
  currentCompanyId: null
}
